<template>
    <div class="d-flex align-items-center" :style="alignmentStyle">
        <AppButton
            v-for="button in buttons"
            :key="button.key"
            :class="button.classes"
            :type="button.type"
            :loading="button.loading"
            :disabled="button.disabled"
            :label="button.label"
            @click="button.key == 'cancel' ? $emit('cancel') : null"
        />
    </div>
</template>

<script>
    export default {
        props: {
            position: { type: String, default: 'left' },
            submitLabel: { type: String, default: '' },
            cancelLabel: { type: String, default: '' },
            loading: { type: Boolean, default: false },
            submitClass: { type: String, default: 'app--button border--button primary' },
            cancelClass: { type: String, default: 'app--button border--button muted' }
        },
        emits: ['cancel'],
        computed: {
            buttons() {
                const submit = this.submitLabel
                    ? {
                          key: 'submit',
                          classes: this.submitClass,
                          type: 'submit',
                          loading: this.loading,
                          label: this.submitLabel
                      }
                    : null
                const cancel = this.cancelLabel
                    ? {
                          key: 'cancel',
                          classes: this.cancelClass,
                          type: 'button',
                          disabled: this.loading,
                          label: this.cancelLabel
                      }
                    : null

                return (this.submitRight ? [cancel, submit] : [submit, cancel]).filter(Boolean)
            },
            submitRight() {
                return (this.position || 'left').toLowerCase() === 'right'
            },
            alignmentStyle() {
                if (this.buttons.length > 1) {
                    return 'justify-content: space-between !important;'
                }
                if (this.buttons.length === 1 && this.buttons[0].key === 'submit') {
                    return 'justify-content: center !important;'
                }

                return ''
            }
        }
    }
</script>
